/**
 * useGarageEnabled — team-level feature gate for the Garage module.
 *
 * Reads `features.garageEnabled` from team settings.
 * Returns `true` when the flag is absent or explicitly `true` (backward compatible).
 *
 * Usage: call once at layout/shell level, pass down via props or use in
 * conditional rendering blocks. Do NOT sprinkle deep in leaf components.
 */

import { useTeamSettings } from '@/features/settings/useTeamSettings';
import { useRequiredTeamId } from '@/hooks/useRequiredTeamId';

export function useGarageEnabled(): boolean {
  const teamId = useRequiredTeamId();
  const { settings } = useTeamSettings(teamId);
  // Default true — absence of field means garage is enabled (backward compatible)
  return settings?.features?.garageEnabled !== false;
}
